import { Station } from '@app/core/types/stations';
import {
  AuditSupportBulkUploadLtxFilesMutationRequest,
  AuditSupportMinUploadLtxResultDto,
  useAuditSupportBulkUploadLtxFiles,
} from '@mi-front/api-v2';
import { ValidateAndUploadFileView } from '../ValidateAndUploadFileView';
import { LtxPreview } from './LtxPreview';

export function LtxUpload({ station }: { station: Station }) {
  return (
    <ValidateAndUploadFileView<
      AuditSupportMinUploadLtxResultDto,
      { data: AuditSupportBulkUploadLtxFilesMutationRequest }
    >
      station={station}
      accept=".ltx,.LTX,.ltx.txt,.LTX.TXT,text/plain"
      fileType="LTX"
      useUploadMutation={useAuditSupportBulkUploadLtxFiles}
      renderPreview={(data) => <LtxPreview entries={data.entries ?? []} />}
    />
  );
}
